import { useTranslate } from '@festina-life/ui/hooks'

import { Attribute } from '../attribute/Attribute'

type Props = {
  count: number
}

export const TemplateConflictsInWorkspace = ({ count }: Props) => {
  const translate = useTranslate()

  return count ? (
    <Attribute className="bg-warning-400! text-amaze-ink!">
      {translate('shadowedTemplateOperation.conflictCount', {
        count,
      })}
    </Attribute>
  ) : null
}
